var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #494848;\n      }\n\n      .cls-3 {\n        opacity: 0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 24,
    height: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "game"
  }, /*#__PURE__*/React.createElement("g", {
    id: "game_group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "game_path_9",
    className: "cls-1",
    d: "m3.4,11.19v.77s0,0,0,0h-.47s-2.81-.01-2.81-.01c0-.07,0-.15,0-.23.01-3.17,2.6-5.74,5.77-5.72h.16s.07,0,.07,0v2.87s-.08,0-.08,0h-.3s0,2.33,0,2.33h-2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game_path_8",
    className: "cls-1",
    d: "m6.08,17.94h-.08s-.15,0-.15,0c-3.17,0-5.74-2.59-5.74-5.76,0-.08,0-.15,0-.23h2.81s.47,0,.47,0v.78s2.33.01,2.33.01v2.33s.29,0,.29,0h.07s0,2.86,0,2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game_path_7",
    className: "cls-1",
    d: "m23.88,11.82c.01-3.18-2.55-5.76-5.73-5.77h-.23s-.03,5.97-.03,5.97h0s2.76.01,2.76.01h3.2c0-.06,0-.14,0-.21Zm-4.48-2.19h.03s0-.01,0-.01h.03c.57-.21,1.2.09,1.4.67,0,.01,0,.03.01.04,0,.01.01.03.02.04.2.57-.11,1.2-.68,1.4h-.03s0,.01,0,.01h-.03c-.57.21-1.2-.09-1.4-.67,0-.01,0-.03-.01-.04,0-.01-.01-.03-.02-.04-.2-.57.1-1.2.68-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game_path_6",
    className: "cls-1",
    d: "m23.89,12.28c0-.08,0-.15,0-.23l-5.97-.04-.04,5.97h.23c3.17.02,5.76-2.54,5.78-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "game_path_5",
    className: "cls-1",
    x: 11.94,
    y: 6.04,
    width: 5.97,
    height: 5.97,
    transform: "translate(.04 -.06) rotate(.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game_path_4",
    className: "cls-1",
    d: "m17.88,17.99v-3.09s.01-.22.01-.22v-2.66s-5.89-.02-5.89-.02h-.07s-.02,5.97-.02,5.97h.07s5.9.03,5.9.03h0Zm-.77-3.37h-.03s0,.01,0,.01h-.03c-.58.21-1.2-.09-1.4-.67,0-.01,0-.03-.01-.04s0-.03-.01-.04c-.2-.57.1-1.2.68-1.4h.03s0-.01,0-.01h.03c.57-.21,1.2.09,1.4.67,0,.01.01.03.01.04,0,.01.01.03.01.04.2.57-.1,1.2-.68,1.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "game_path_3",
    className: "cls-1",
    points: "12 12 11.93 12 9.61 11.99 9.61 11.21 7.28 11.2 7.29 8.87 6.11 8.87 6.04 8.87 6.05 6 6.12 6 11.96 6.03 12.03 6.03 12 12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "game_path_2",
    className: "cls-1",
    points: "6.1 11.98 6.09 11.98 6.1 11.97 6.1 11.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "game_path_1",
    className: "cls-1",
    points: "11.98 17.97 11.91 17.97 6 17.95 6 17.94 6.01 15.08 6.08 15.08 7.27 15.09 7.28 12.76 9.61 12.77 9.61 11.99 11.93 12 12 12 11.98 17.97"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGame);
export default __webpack_public_path__ + "static/media/icon_game.7eb4379e50b68913747f2ab1300ef07f.svg";
export { ForwardRef as ReactComponent };